/**
 * Copyright 2016 xdot GmbH
 *
 * Author: Carsten Hibbeler
 * Date: 28.01.2016
 *
 */
import KeyStateStore from './KeyStateStore';

import ActionTypesCommon from '../constants/ActionTypesCommon';
import AsyncState from '../constants/AsyncState';

export default class ConfigStore extends KeyStateStore {

    getConfig(scopeGroupId, plid, portletId){
        return this.getStateByKey(scopeGroupId + plid + portletId);
    }

    getLocalConfig(scopeGroupId, plid, portletId){
        return localStorage[this.getStateByKey(scopeGroupId + plid + portletId)];
    }

    getKeyFromAction(action){
        return action.meta && action.meta.scopeGroupId && action.meta.plid && action.meta.portletId &&
            action.meta.scopeGroupId + action.meta.plid + action.meta.portletId;
    }

    getReducer(action){
        let key = this.getKeyFromAction(action);
        switch (action.type) {
            case ActionTypesCommon.CONFIG_SET:
                return this.setConfigFromAction(key);
            case ActionTypesCommon.CONFIG_UPDATE_ASYNC:
            case ActionTypesCommon.CONFIG_LOAD_ASYNC:
                if (action.meta.asyncState === AsyncState.SUCCESS) {
                    return this.setConfigFromAction(key);
                }
                break;
        }
    }

    setConfigFromAction(key){
        return (state, action) => {
            const localConfig = this.getLocalConfig(key);
            if (localConfig) {
                return {
                    ...action.payload,
                    localConfig
                };
            }
            return { ...action.payload };
        };
    }

}




// WEBPACK FOOTER //
// ./js/stores/ConfigStore.js